import useMultiValueListData from "../../hooks/multiValuelist"

interface IMultiCvtProps {
  lists: string[]
  code: string
}

const MultiCvt = (props: IMultiCvtProps) => {
  const value = useMultiValueListData(props.lists, props.code)

  return <>{value}</>
}

export default MultiCvt
